module.exports = __webpack_public_path__ + "img/share_tips.1dc50274.png";